export enum RpcMethods {
    GET_TOKEN_METHOD = 'csrf.getToken',
    PRODCAT_METHOD = 'prodcat',
    TRANS_GET_RPC_METHOD = 'trans.get',
    UPDATE_BAG_RPC_METHOD = 'rpc.form',
    OFFERS_QUERY_METHOD = 'api.v1_1.offers.query',
    OFFERS_APPLY_METHOD = 'offers.apply',
    OFFERS_REMOVE_METHOD = 'offer.removeOfferByCode',
    OFFERS_MATCHING_METHOD = 'offer.offersMatching'
}
